import React, { useEffect, useState } from "react";
import MatchStats from "../common/MatchStats";
import NoDataFound from "../common/NoDataFound";
import { calculatePercentagestats } from "../../utils/generalLiveCenter";
import { loadStyles } from "../../utils/cssLoader";

const BasketballStats = ({
  data,
  loadCSS = true,
  dataClient = false,
  title,
}) => {
  const [clientData, setClientData] = useState(null);
  const [selectedQuarter, setSelectedQuarter] = useState("all");

  useEffect(() => {
    if (!dataClient) return;
    const container = document?.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data?.data;
      setClientData(parsed || null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS) {
      loadStyles("basketballstats");
    }
  }, [loadCSS]);

  const matchStats = dataClient ? clientData : data;

  if (!matchStats) {
    return <NoDataFound />;
  }

  // Get available quarters from data
  const getAvailableQuarters = () => {
    const quarters = ["all"];
    if (matchStats?.q1) quarters.push("q1");
    if (matchStats?.q2) quarters.push("q2");
    if (matchStats?.q3) quarters.push("q3");
    if (matchStats?.q4) quarters.push("q4");
    if (matchStats?.ot) quarters.push("ot");
    return quarters;
  };

  const availableQuarters = getAvailableQuarters();

  // Get stats for selected quarter or all
  const getStatsForQuarter = () => {
    const statsData = selectedQuarter === "all"
      ? matchStats?.stats || matchStats
      : matchStats?.[selectedQuarter]?.stats || matchStats?.[selectedQuarter];

    if (!statsData) return [];

    // Common basketball stats to display
    const statKeys = [
      { key: "free_throws", label: "Free Throws" },
      { key: "two_pointers", label: "2 Pointers" },
      { key: "three_pointers", label: "3 Pointers" },
      { key: "field_goals", label: "Field Goals" },
      { key: "rebounds", label: "Rebounds" },
      { key: "defensive_rebounds", label: "Defensive Rebounds" },
      { key: "offensive_rebounds", label: "Offensive Rebounds" },
      { key: "assists", label: "Assists" },
      { key: "turnovers", label: "Turnovers" },
      { key: "blocks", label: "Blocks" },
      { key: "fouls", label: "Fouls" },
      { key: "steals", label: "Steals" },
      { key: "max_points_in_row", label: "Max Points in a Row" },
      { key: "time_spent_in_lead", label: "Time Spent in Lead" },
      { key: "biggest_lead", label: "Biggest Lead" },
    ];

    const formattedStats = [];

    statKeys.forEach(({ key, label }) => {
      const stat = statsData[key];
      if (stat && (stat.ht !== undefined || stat.at !== undefined)) {
        const htVal = stat.ht || 0;
        const atVal = stat.at || 0;
        formattedStats.push({
          type: label,
          ht: htVal,
          at: atVal,
          htPercent: calculatePercentagestats(htVal, atVal),
          atPercent: calculatePercentagestats(atVal, htVal),
        });
      }
    });

    return formattedStats;
  };

  const stats = getStatsForQuarter();

  const quarterLabels = {
    all: "All",
    q1: "Q1",
    q2: "Q2",
    q3: "Q3",
    q4: "Q4",
    ot: "OT",
  };

  return (
    <div className="basketball_stats_container">
      {title && <h1>{title}</h1>}

      {availableQuarters.length > 1 && (
        <div className="stats_filters">
          <div className="quarter_selector">
            {availableQuarters.map((quarter) => (
              <button
                key={quarter}
                className={`filter_button ${selectedQuarter === quarter ? "active" : ""}`}
                onClick={() => setSelectedQuarter(quarter)}
              >
                {quarterLabels[quarter]}
              </button>
            ))}
          </div>
        </div>
      )}

      {stats.length > 0 ? (
        <div className="stats-holder">
          <MatchStats stats={stats} />
        </div>
      ) : (
        <NoDataFound />
      )}
    </div>
  );
};

export default BasketballStats;
